import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Home from './pages/Home';
import Quiz from './pages/Quiz';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import Leaderboard from './pages/Leaderboard'; // Import de la page Leaderboard
import Administration from './pages/Administration'; // Import de la page Administration
import Instructions from './pages/Instructions';

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('token'));
  const [isAdmin, setIsAdmin] = useState(localStorage.getItem('isAdmin') === 'true'); // Vérifier le rôle admin

  // Mettre à jour isAdmin lorsqu'une connexion a lieu
  const handleLogin = () => {
    setIsLoggedIn(true);
    setIsAdmin(localStorage.getItem('isAdmin') === 'true'); // Mettre à jour après la connexion
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('isAdmin'); // Nettoyer le statut admin
    setIsLoggedIn(false);
    setIsAdmin(false);
  };

  return (
    <Router>
      <nav style={{ textAlign: 'center', margin: '20px' }}>
        <Link to="/">Accueil</Link> | <Link to="/instructions">Instructions</Link> | <Link to="/quiz">Quiz</Link> |{' '}
        <Link to="/leaderboard">Classement</Link> {/* Lien vers la page Leaderboard */}
        {isLoggedIn && isAdmin && (
          <> | <Link to="/admin">Administration</Link> </> // Lien visible uniquement pour les admins
        )}
        {isLoggedIn ? (
          <>
            | <Link to="/profile">Mon Profil</Link> |{' '}
            <button onClick={handleLogout} style={{ border: 'none', background: 'none', cursor: 'pointer', color: 'blue' }}>
              Déconnexion
            </button>
          </>
        ) : (
          <>
            | <Link to="/login">Connexion</Link> | <Link to="/register">Inscription</Link>
          </>
        )}
      </nav>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/quiz" element={isLoggedIn ? <Quiz /> : <Login onLogin={handleLogin} />} />
        <Route path="/login" element={<Login onLogin={handleLogin} />} />
        <Route path="/register" element={<Register />} />
        <Route path="/profile" element={isLoggedIn ? <Profile /> : <Login onLogin={handleLogin} />} />
        <Route path="/instructions" element={<Instructions />} />
        <Route path="/leaderboard" element={<Leaderboard />} /> {/* Route pour Leaderboard */}
        <Route
          path="/admin"
          element={
            isLoggedIn && isAdmin ? (
              <Administration />
            ) : (
              <Login onLogin={handleLogin} />
            )
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
